import React, { useState } from "react";
import ClientFiltersDialog from "./ClientFiltersDialog";
import FilterChipDisplay from "../../../Filtering/FilterChipDisplay";
import ScorecardFiltersViewModel from "../../Viewmodels/ScorecardFiltersViewModel";


interface IClientFiltersProps {
    client: string;
    changeFilter: (filterName: keyof ScorecardFiltersViewModel, newValue: any) => void;
}

export default function ClientFilters({ client, changeFilter }: IClientFiltersProps) {
    const [dialogOpen, setDialogOpen] = useState(false);

    const text = `Client: ${client}`

    return (
        <>
            <FilterChipDisplay
                text={text}
                selectable
                onClick={() => setDialogOpen(true)} />
            <ClientFiltersDialog
                open={dialogOpen}
                setOpen={setDialogOpen}
                currentClient={client}
                changeFilter={changeFilter} />
        </>
    )
}